<div
  [ngStyle]="{ 'background-color': backgroundColor }"
  [ngClass]="sectionClass"
>
  @for (item of components; track item.UUID) {
    @switch (item.type) {
      @case (TypeComponent.BUTTON) {
        <lib-app-button
          [component]="item"
        ></lib-app-button>
      }
      @case (TypeComponent.TEXT) {
        <lib-text
          [component]="item"
        ></lib-text>
      }
      @case (TypeComponent.IMAGE) {
        <lib-image
          [component]="item"
        ></lib-image>
      }
      @case (TypeComponent.VIDEO) {
        <lib-video
          [component]="item"
        ></lib-video>
      }
      @case (TypeComponent.IMAGE_BUTTON) {
        <lib-button-image
          [component]="item"
        ></lib-button-image>
      }
      @case (TypeComponent.CARROUSEL) {
        <lib-carousel
          [component]="item"
        ></lib-carousel>
      }
      @case (TypeComponent.S10) {
        <lib-s10
          [component]="item"
        ></lib-s10>
      }
    }
  }
</div>
